<fuse-widget class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">

        <div class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg" fxLayout="row"
                    fxLayoutAlign="space-between center">
            <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4">{{title}}</div>
                <div *ngIf="data?.length>0" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 secondary">({{data?.length}})</div>
                </div>
            </div>
        </div>

        <div *ngIf="data?.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlex>
            <span class="mat-h1 hint-text py-48">There are no reviews</span>
        </div> 

        <div *ngIf="data?.length>0" class="data-list">
            <div class="p-16 clickable row list-item" *ngFor="let row of data" (click)="select(row);" (dblclick)="view(row)" [ngClass]="{'selected':row?.id == selected?.id}">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="flex-grow:1">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div class="status {{row.class}}">{{row.status}}</div>
                            <div class="pl-12" fxLayout="row" fxLayoutAlign="start center">
                                <div fxLayout="column">
                                    <div class="h3">{{row.reviewDate | dateFormat}}{{row.label}} {{(row.override ? '(override)' : '')}}</div>
                                    <div>
                                        <span class="secondary-text">{{row.secondary}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button mat-icon-button aria-label="View" class="mat-icon-button" matTooltip="View Comments" (click)="view(row);">
                        <mat-icon>open_in_browser</mat-icon>
                    </button>  
                </div>
            </div>
        </div>
    </div>


    <!-- / Front -->

</fuse-widget>